import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import packageJson from '../../package.json';

const bugsnagClient = Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_KEY,
  releaseStage: import.meta.env.VITE_ENV,
  appVersion: packageJson.version,
  enabledReleaseStages: ['production', 'staging', 'develop'],
  plugins: [new BugsnagPluginReact()],
});

export default bugsnagClient;
